"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _reactRedux = require("react-redux");

var _comparisonTable = _interopRequireDefault(require("../comparison-table/comparison-table"));

var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config,
    selectedVehicle: state.compareSelection.selectedVehicle,
    selectedYear: state.compareSelection.selectedYear,
    models: state.vehicleCompare.modelSelectedList
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(_comparisonTable["default"]);

exports["default"] = _default;